import isEqual from 'lodash/isEqual';

import { setGlobalPluginAction, setInstalledPluginsAction } from 'editor/src/store/design/slice';
import { DesignData } from 'editor/src/store/design/types';
import { GalleryImage } from 'editor/src/store/gallery/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { Plugin, PluginName } from 'editor/src/store/plugins/types';
import { isEmbedded } from 'editor/src/store/watchers/useDisplayMode';

import { getRelevantGlobalPlugins } from '../../variants/operation/getRelevantGlobalPlugins';

import getAppliedPlugins from './getAppliedPlugins';

function checkPluginUse(
  designData: DesignData,
  images: GalleryImage[],
  dispatch: ThunkDispatch,
  plugins: Plugin[],
  globalPlugins: string[],
  defaultPersonalizationPlugin = false,
) {
  if (isEmbedded) {
    return; // skip modifying plugins in case of embedded mode
  }

  let effectiveGlobalPlugins = globalPlugins;
  if (!defaultPersonalizationPlugin) {
    const relevantGlobalPlugins = getRelevantGlobalPlugins(globalPlugins as PluginName[], plugins);
    if (!isEqual(relevantGlobalPlugins, globalPlugins)) {
      dispatch(setGlobalPluginAction(relevantGlobalPlugins));
      effectiveGlobalPlugins = relevantGlobalPlugins;
    }
  }

  const appliedPlugins = [...getAppliedPlugins(designData, plugins, images, effectiveGlobalPlugins)];
  if (!isEqual(appliedPlugins, designData.plugins)) {
    dispatch(setInstalledPluginsAction(appliedPlugins));
  }
}

export default checkPluginUse;
